export enum QuestionType {
  DataEntry = 1,
  YesNo = 2,
  List = 3,
  Informational = 4,
  Combo = 5,
}
